import React from 'react';

export interface DescriptionListRow {
    key?: React.Key;
    title: React.ReactNode;
    data: React.ReactNode;
}

interface DescriptionListProperties {
    rows: readonly DescriptionListRow[];
}

export default function DescriptionList({ rows }: DescriptionListProperties): React.ReactElement {
    return (
        <dl className="popup-table">
            {rows.map((row, index) => (
                <React.Fragment key={row.key ?? `title-${index}`}>
                    <dt>{row.title}</dt>
                    <dd>{row.data}</dd>
                </React.Fragment>
            ))}
        </dl>
    );
}
